import React from 'react';
/** Components Import */
import { Snackbar as MuiSnackbar, Alert as MuiAlert } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { closeSnackbar } from '../../Reducer/SnackbarReducer';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} {...props} />;
});

function SnackbarBasic({
  /** Snackbar Props */
  action, // node
  anchorOrigin = { vertical: 'bottom', horizontal: 'center' }, // { horizontal: 'center' | 'left' | 'right', vertical: 'bottom' | 'top' }
  autoHideDuration = 3000, // number
  classes, // object
  ClickAwayListenerProps, // object
  ContentProps, // object
  disableWindowBlurListener = false, // bool
  key = anchorOrigin.vertical + anchorOrigin.horizontal, // any
  resumeHideDuration, // number
  sx, // object
  onClose = () => {},
  /** Alert Props */
  alertAction, // node
  alertChildren, // node
  alertClasses, // object
  alertCloseText = '', // string
  alertColor, // 'error' | 'info' | 'success' | 'warning' | string
  alertComponents, // { CloseButton?: elementType, CloseIcon?: elementType }
  alertComponentsProps, // { closeButton?: object, closeIcon?: object }
  alertIcon, // node
  alertIconMapping, // { error?: node, info?: node, success?: node, warning?: node }
  alertRole = 'alert', // string
  alertSlotProps, // { closeButton?: func | object, closeIcon?: func | object }
  alertSlots, // { closeButton?: elementType, closeIcon?: elementType }
  alertSx, // object
  alertVariant = 'standard', // 'filled' | 'outlined' | 'standard'
  alertOnClose = () => {},
}) {
  const dispatch = useDispatch();
  const { open, message, type } = useSelector((state) => state.snackbar);
  const { navBar } = useSelector((state) => state.systemBar);

  const CloseSnackbar = () => {
    dispatch(closeSnackbar());
  };

  return (
    <MuiSnackbar
      action={action}
      anchorOrigin={anchorOrigin}
      autoHideDuration={autoHideDuration}
      classes={classes}
      ClickAwayListenerProps={ClickAwayListenerProps}
      ContentProps={ContentProps}
      disableWindowBlurListener={disableWindowBlurListener}
      key={key}
      message={message}
      open={open}
      resumeHideDuration={resumeHideDuration}
      sx={{
        ...sx,
        zIndex: 4000,
        bottom: `${navBar + 16}px !important`,
      }}
      onClose={CloseSnackbar}
    >
      <Alert
        action={alertAction}
        children={alertChildren}
        classes={alertClasses}
        closeText={alertCloseText}
        color={alertColor}
        components={alertComponents}
        componentsProps={alertComponentsProps}
        icon={alertIcon}
        iconMapping={alertIconMapping}
        role={alertRole}
        severity={type}
        slotProps={alertSlotProps}
        slots={alertSlots}
        sx={{
          ...alertSx,
          width: '90%',
          py: 0,
        }}
        variant={alertVariant}
        // onClose={alertOnClose}
      >
        {message}
      </Alert>
    </MuiSnackbar>
  );
}

export default React.memo(SnackbarBasic);
